export interface IUserProfile {
  userId: string;
  customerId: string;
  fullName: string;
  portalLink: string;
  expandedNav: string;
  featureFlags: IFeatureFlagConfiguration[];
  beamerKey?: string;
  userFlowKey?: string;
  knowledgeBaseLink?: string;
  featureDiscussionLink?: string;
  helpdeskLink?: string;
  timeZone?: string | null; // tenant IANA zone, e.g. "Europe/London"; missing on older backends
  locale?: string | null; // tenant BCP-47 locale, e.g. "en-GB"; missing on older backends
  firstDayOfWeek?: string | null; // DayOfWeek name from the tenant's culture, e.g. "Sunday"; missing on older backends
}

export interface IFeatureFlagConfiguration {
  name: string;
  state: FeatureFlagState;
}

export enum FeatureName {
  homePage = "Home page",
  performanceTab = "R3: Success Intelligence: Performance tab",
  sentimentTab = "Sentiment tab",
  objectionsTab = "R3: Success Intelligence",
  unifiedFilters = "Unified Filters",
  topicsTab = "Topics tab",
  isCcaaSFiltersMetricsHidden = "Hide CcaaS Filters Metrics",
  scoringScorecardsPage = "Scorecards page",
  scoringSchedulesPage = "Auto QA Schedules page",
  promptStudioPage = "Prompt Studio page",
  scorecardResultExport = "Scorecard Result export",
  scorecardExport = "Scorecard export",
  questionLevelReporting = "Question-Level Reporting",
}

export enum FeatureFlagState {
  disabled = "Disabled",
  enabled = "Enabled",
  payWall = "PayWall",
}
